import { TariffGroupAttribute } from '@src/core/buyerApiClient';

import { buildLanguageOptions } from '@src/domains/products/features/product-booking/core/language/buildLanguageOptions';
import {
  LANGUAGE_ATTRIBUTE_TYPE,
  isLanguageAttributeType,
  type AttributeOption,
  type TariffGroupAttributeType,
} from '@src/domains/products/features/product-booking/types/attribute';

export const isActiveAttribute = (attribute: TariffGroupAttribute): boolean => !attribute.deletedAt;

export const orderedAttributeTypes = (attributes: TariffGroupAttribute[]): TariffGroupAttributeType[] => {
  const seen = new Set<TariffGroupAttributeType>();
  const types: TariffGroupAttributeType[] = [];

  for (const attribute of attributes) {
    if (!isActiveAttribute(attribute) || seen.has(attribute.type)) {
      continue;
    }

    seen.add(attribute.type);
    types.push(attribute.type);
  }

  return [
    ...types.filter((type) => isLanguageAttributeType(type)),
    ...types.filter((type) => !isLanguageAttributeType(type)),
  ];
};

export const buildAttributeOptions = (
  attributes: TariffGroupAttribute[],
  type: TariffGroupAttributeType,
): AttributeOption[] => {
  if (isLanguageAttributeType(type)) {
    return buildLanguageOptions(attributes);
  }

  const seen = new Set<string>();
  const options: AttributeOption[] = [];

  for (const attribute of attributes) {
    if (!isActiveAttribute(attribute) || attribute.type !== type) {
      continue;
    }

    const value = attribute.value.trim();
    if (!value || seen.has(value)) {
      continue;
    }

    seen.add(value);
    options.push({ value, label: value });
  }

  return options;
};

export { LANGUAGE_ATTRIBUTE_TYPE };
